import { Component, OnInit } from '@angular/core';
import { Storage } from '../../utilities/storage';
import { Helpers } from '../../utilities/helpers';
import { environment } from '../../../../environments/environment';
import { Router, ActivatedRoute, NavigationExtras } from '@angular/router';
import { SharedPreferencesService } from '../../services/shared-preferences.service';

@Component({
  selector: 'app-home',
  templateUrl: './home.component.html',
  styleUrls: ['./home.component.scss']
})
export class HomeComponent implements OnInit {

  selectedLocation: any = null;
  selectedCategory: any = null;
  locations: any[];
  categories: any[];

  constructor(
    public sharedPreferencesService: SharedPreferencesService,
    public router: Router
  ) {
    this.sharedPreferencesService.showHeader = false;
    this.sharedPreferencesService.showMapCategoryToggle = false;
    
    this.locations = this.sharedPreferencesService.locations;
    this.categories = this.sharedPreferencesService.categories;

    this.selectedLocation = this.getLocationStorage();
    this.selectedCategory = this.getCategoryStorage();

    // Helpers.getLocation()
    //   .then((position: Position) => {
    //     let lat = position.coords.latitude;
    //     let long = position.coords.longitude;
    //     let usersLocation = this.getNearestLocation(lat, long);

    //     if(this.selectedLocation)
    //   })
    //   .catch((err) => {
    //     console.log('Error getting the location', err);
    //   })
  }

  ngOnInit() {
    let params = Helpers.getHttpParams();

    if(params.category) {
      let category = this.sharedPreferencesService.getCategory('slug', params.category);
      if(category) {
        this.selectedCategory = category;
      }
    }

    if(params.location) {
      let location = this.sharedPreferencesService.getLocation('slug', params.location);

      console.log(location);
      if(location) {
        this.selectedLocation = location;
      }
    }
  }

  getCategoryStorage() {
    let storageValue = Storage.get('selected_category') ? Storage.get('selected_category') : 1;

    return this.sharedPreferencesService.getCategory('id', storageValue);
  }

  getLocationStorage() {
    let storageValue = Storage.get('selected_location') ? Storage.get('selected_location') : 1;

    return this.sharedPreferencesService.getLocation('id', storageValue);
  }

  getNearestLocation(lat, long) {
    let shortestDistance = null;
    let nearestLocation = null;
    for(let location of this.locations) {
      let distance = Math.sqrt(Math.pow(location.lat - lat, 2) + Math.pow(location.long - long, 2));
      if(!shortestDistance || shortestDistance > distance) {
        shortestDistance = distance;
        nearestLocation = location;
      }
    }
    return nearestLocation;
  }

  navigateToAroundMeComponent() {
    let navigationExtras: NavigationExtras = {
      queryParams: { lat: this.selectedLocation.lat, long: this.selectedLocation.long, radius: this.selectedLocation.radius, autoAdjustMarkers:true },
    };
    
    this.router.navigate(['/around-me', this.selectedLocation.slug, this.selectedCategory.slug], navigationExtras)
  }
}



// WEBPACK FOOTER //
// /Users/jaswantsingh/Documents/GitHub/maps/src/app/core/components/home/home.component.ts